var $8f3062061aa45e2f$exports = {};
$8f3062061aa45e2f$exports = {
    "breadcrumbs": `\u{3A0}\u{3BB}\u{3BF}\u{3B7}\u{3B3}\u{3AE}\u{3C3}\u{3B5}\u{3B9}\u{3C2} breadcrumb`
};


export {$8f3062061aa45e2f$exports as default};
//# sourceMappingURL=el-GR.mjs.map
